import { useSelector } from 'react-redux';

import { StoreState } from '@bcp-nextgen-dx-touchpoint-framework/react-js';
import { AppState } from '@store';

export const useGetEmails = (): string[] => {
	const corporateEmail = useSelector(
		(state: StoreState<AppState>) =>
			state.appState.userInputState.forms?.corporateData?.corporateInfo?.email as string
	);
	const responsibleEmail = useSelector(
		(state: StoreState<AppState>) =>
			state.appState.userInputState.forms?.corporateData?.responsibleInfo?.email as string
	);
	return [corporateEmail, responsibleEmail];
};
